import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Headerinner";
import Breadcrumbs from "../layouts/Breadcrumb";
import Footer from "../layouts/Footer";
import Content from "../sections/menu-item-v1/Content";
import { getRestaurant } from "../../utils/commons";
import { useParams } from "react-router-dom";

const pagelocation = "Commandez en ligne";
const restaurant = getRestaurant();

const Menuitemone = (props) => {
	const { menuId } = useParams();

	return (
		<Fragment>
			<MetaTags>
				<title>
					{restaurant.name} | {pagelocation}
				</title>
				<meta name="description" content="#" />
			</MetaTags>
			<Header />
			{/* <Breadcrumbs breadcrumb={{ pagename: pagelocation }} /> */}
			<Content productId={menuId} goToHome={() => (window.location = "/")} />
			<Footer
				footer={{
					style: "ct-footer footer-dark",
					logo: "assets/img/logo-light.png",
				}}
			/>
		</Fragment>
	);
};

export default Menuitemone;
